import { render } from "./CardProductVertical.vue?vue&type=template&id=18f54378&scoped=true"
import script from "./CardProductVertical.vue?vue&type=script&lang=js"
export * from "./CardProductVertical.vue?vue&type=script&lang=js"

import "./CardProductVertical.vue?vue&type=style&index=0&id=18f54378&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18f54378"]])

export default __exports__